import { LoadingOutlined } from "@ant-design/icons";
import { Divider, Flex, Grid, Image, Modal } from "antd";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import WarperResult from "../../assets/images/minhngocstar/minhngocstar-result-bg.png";
import { FindResult, HistoryResult, ResultLottery } from "../../components";
import Container from "../../components/Container";
import { MINHNGOC_ID } from "../../constants/Configs";
import { useGetHistoryRewardLottoMutation, useGetRewardLottoMutation } from "../../servies/RewardService";
import { generateData } from "../../utils/GenerateNumber";

const { useBreakpoint } = Grid;

const color = "#e80000";
const warper_bg = "#fff";
const color_bg = "white";
export default function MinhngocPage() {
    const screens = useBreakpoint();

    const [data, setData] = useState({});
    const [statusReward, setStatusReward] = useState("LOADING");
    const [rewardDetail, setRewardDetail] = useState({});
    const [historyData, setHistoryData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingHistory, setLoadingHistory] = useState(true);

    const [getReward] = useGetRewardLottoMutation();
    const [getHistoryReward] = useGetHistoryRewardLottoMutation();

    const [reloadTime, setReloadTime] = useState("");
    const [currentTime, setCurrentTime] = useState("");
    const [time, setTime] = useState(0);
    const convertTime = (date) => {
        return dayjs(date).tz("Asia/Bangkok").format("HH:mm:ss");
    };

    useEffect(() => {
        const timeReload = setInterval(() => {
            const now = convertTime(dayjs(currentTime).tz("Asia/Bangkok").add(time, "s").toISOString());
            const reload_time = convertTime(reloadTime);
            setTime((prev) => prev + 10);
            if (statusReward == "ANNOUNCED") {
                clearInterval(timeReload);
            }
            if (reload_time < now && statusReward !== "ANNOUNCED") {
                fetchReward();
            }
        }, 10000);
        return () => {
            clearInterval(timeReload);
        };
    });

    const fetchReward = useCallback(async () => {
        try {
            const result = await getReward({ huayId: MINHNGOC_ID }).unwrap();
            const result_history = await getHistoryReward({ huayId: MINHNGOC_ID }).unwrap();

            setReloadTime(result?.data?.reloadTime);
            setCurrentTime(result?.data?.serverTime);

            setStatusReward(result?.data?.viewStatus);
            setRewardDetail(result?.data);
            if (result?.data?.viewStatus === "ANNOUNCED") {
                const _data = generateData(result?.data?.result?.primaryNumber);
                setData(_data);
            }
            const _result_history =
                result_history?.data?.map((item) => {
                    return {
                        date: item?.roundName,
                        result: item?.result?.primaryNumber,
                    };
                }) || [];
            setHistoryData([..._result_history]);
        } catch (error) {
            Modal.error({
                title: "An error occurred. !",
                content: "Please try again.",
                okText: "Close",
                okType: "danger",
            });
        } finally {
            setLoading(false);
            setLoadingHistory(false);
        }
    }, [getReward, getHistoryReward]);

    useEffect(() => {
        document.title = "Trực tiếp kết quả xổ số Miền Nam » Tường thuật từng giây » Minh Ngọc™ JACKPOT";
        fetchReward();
    }, [fetchReward]);

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <link rel="icon" href={require("../../assets/images/minhngoc/minhngoc-icon.png")} />
            </Helmet>
            {(loading || loadingHistory) && (
                <div className="fixed top-0 left-0 inset-0  flex  justify-center items-center backdrop-opacity-10 backdrop-invert bg-black/50 z-50 ">
                    <LoadingOutlined
                        style={{
                            color: "#fff",
                            fontSize: 40,
                        }}
                        spin
                    />

                    <div className="pl-4 text-sky-50">Loading ...</div>
                </div>
            )}
            <Container className={"relative items-center flex flex-col"}>
                <div style={{ height: "100vh", width: "100vw", position: "fixed", zIndex: -2, background: warper_bg }} />
                {/* header logo */}
                <Flex
                    align={!screens.sm ? "start" : "center"}
                    style={{
                        background: "white",
                        maxWidth: 1024,
                        width: "100%",
                        height: "100%",
                    }}
                    vertical={!screens.sm}
                >
                    <Image
                        src={require("../../assets/images/minhngoc/minhngoc-header-2.png")}
                        rootClassName="max-w-[400px] mt-2"
                        preview={false}
                    />

                    <Image src={require("../../assets/images/minhngocstar/minhngocstar-1.gif")} preview={false} />
                </Flex>

                {/* line */}
                <Flex
                    vertical
                    style={{
                        backgroundPosition: "bottom",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        maxWidth: 1024,
                        width: "100%",
                    }}
                >
                    <div className="pt-2">
                        <Flex gap={10} vertical={!screens.md}>
                            <Flex className="hidden md:block md:w-full md:max-w-[200px] order-1 md:order-0" vertical gap={10}>
                                <Image
                                    src={require("../../assets/images/minhngocstar/minhngocstar-1.png")}
                                    rootClassName="w-full"
                                    preview={false}
                                />
                                <Image src={require("../../assets/images/minhngoc/minhngoc-1.gif")} preview={false} />
                            </Flex>
                            <Flex className="w-full order-0 md:order-1 sm:mx-0" vertical>
                                <Flex vertical gap={10} className="mb-3 px-3 sm:px-0">
                                    <Image
                                        src={require("../../assets/images/minhngocstar/minhngocstar-2.png")}
                                        rootClassName="w-full"
                                        preview={false}
                                    />
                                </Flex>
                                <div className="md:hidden block">
                                    <FindResult
                                        date={rewardDetail?.roundName}
                                        rewardData={data}
                                        color={color}
                                        bgColor={color_bg}
                                        lang="VIM"
                                    />
                                </div>

                                <div className="px-3 sm:px-0">
                                    <Image src={require("../../assets/images/minhngoc/minhngoc-2.gif")} preview={false} />

                                    <Flex
                                        style={{
                                            backgroundImage: `url(${WarperResult})`,
                                            backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "100% 100%",
                                            width: "100%",
                                            height: 45,
                                            fontSize: 18,
                                            color: "white",
                                        }}
                                        justify="center"
                                        align="center"
                                    >
                                        TRỰC TIẾP XỔ SỐ MIỀN NAM: {rewardDetail?.roundName}
                                    </Flex>
                                </div>
                                {/* content result */}
                                <ResultLottery
                                    status={statusReward}
                                    data={data}
                                    date={rewardDetail?.roundName}
                                    color={color}
                                    bgColor={color_bg}
                                    lang="VIM"
                                />
                                {/* history */}
                                <div className="my-0">
                                    <HistoryResult data={historyData} color={color} bgColor={color_bg} lang="VIM" />
                                </div>
                            </Flex>

                            <Flex className="w-full md:max-w-[330px] order-1 md:order-0" vertical>
                                <div className="md:block hidden">
                                    <FindResult
                                        date={rewardDetail?.roundName}
                                        rewardData={data}
                                        color={color}
                                        bgColor={color_bg}
                                        lang="VIM"
                                    />
                                </div>
                                <Image src={require("../../assets/images/minhngoc/minhngoc-3.gif")} preview={false} />
                            </Flex>
                        </Flex>
                    </div>
                </Flex>

                <Divider className="m-0 mt-3 h-[2px]" />
                <Flex align="center" className="mt-2">
                    <Flex vertical>
                        <center className="text-[#848484]">Hệ Thống Đại Lý Vé Số Kiến Thiết MINH NGỌC</center>
                        <center className="text-[#C6C6C6]">Đ/c: 117-119 Ngô Tất Tố, F 22, Bình Thạnh, TP. HCM, Việt Nam.</center>
                        <center className="text-[#848484]">Tel: 028 6266 2222 - 090 363 7779</center>
                        <center className="text-[#800000]">ĐỔI VÉ SỐ TRÚNG THƯỞNG Hotline: 0973 777779</center>
                    </Flex>
                    <Image
                        src={require("../../assets/images/minhngoc/minhngoc-footer.png")}
                        rootClassName="px-10"
                        preview={false}
                    />
                    <Flex vertical>
                        <center className="text-[#848484]">Công Ty TNHH Đầu Tư Thương Mại & Dịch Vụ MINH NGỌC</center>
                        <center className="text-[#C6C6C6]">Minh Ngoc Investment Trading And Services Company Limited</center>
                        <center className="text-[#C6C6C6]">
                            Dien Bien Phu Street, 21 Ward, Binh Thanh Dist, HCM City, Vietnam.
                        </center>
                    </Flex>
                </Flex>
                <center className="text-[#666] font-normal text-base w-full py-3">
                    Copyright © 1996 - 2018 MINH NGOC GROUP All Rights Reserved. Điều khoản sử dụng | www.minhngoc.net |
                    www.doisotrung.net
                </center>
            </Container>
        </div>
    );
}
